module.exports = __webpack_public_path__ + "img/Logo_IACC.670362a4.png";